module.exports = __webpack_public_path__ + "static/img/preview-03.98493a97.webp";